<template>

  <!-- start container -->
  <div class="row bg-white max-height-vertical max-height-full box-overflow">
    <div class="row scroll-outer" ref="scrollContainer">
      <div>

        <!-- start content -->
        <div class="row padding-top-96">
          <div class="span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
            <h1 class="upcase">Pre-Survey</h1>
            <p>To help us better serve you and your students, please fill out this quick survey before beginning this module.</p>
            <p v-if="showErrorMessage" class="color-red subheader">Please fill out all required fields.</p>
          </div>
        </div>

        <!--  -->
        <div class="border-error-container" :class="[presurvey_0_group, presurvey_1_group]">
          <survey-caption ind="1">
            <p class="p subheader upcase border-error-container">School</p>
          </survey-caption>

          <div class="row">
            <div class="span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
              <!-- border-red-important -->
              <input type="text" class="form-text-area text-area-small p transform-up-24-lg" placeholder="School Name" ref="presurvey-0-group"
                v-on:keyup="textToStore('presurvey-0-group', 'School Name')"></input>
            </div>
            <div class="span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
              <!-- border-red-important -->
              <input type="text" class="form-text-area text-area-small p transform-up-24-lg" placeholder="School District" ref="presurvey-1-group"
                v-on:keyup="textToStore('presurvey-1-group', 'School District')"></input>
            </div>
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="border-error-container" :class="[presurvey_2_group]">
          <survey-caption ind="2">What position do you hold?</survey-caption>

          <div class="row span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
            <radio-span group="presurvey-2-group" survey="true" title="Teacher" groupQuestion="What position do you hold?"></radio-span>
            <radio-span group="presurvey-2-group" survey="true" title="School Administrator" groupQuestion="What position do you hold?"></radio-span>
            <radio-span group="presurvey-2-group" survey="true" title="School Counselor" groupQuestion="What position do you hold?"></radio-span>
            <radio-span group="presurvey-2-group" survey="true" title="Social Worker/School Nurse/Wellness Center Staff" groupQuestion="What position do you hold?"></radio-span>
            <radio-span group="presurvey-2-group" survey="true" title="School Climate/Attendance Coordinator" groupQuestion="What position do you hold?"></radio-span>
            <radio-span group="presurvey-2-group" survey="true" title="District Administrator" groupQuestion="What position do you hold?"></radio-span>
            <radio-span group="presurvey-2-group" survey="true" title="Other" groupQuestion="What position do you hold?"></radio-span>
          </div>

          <div class="row">
            <div class="span-5-lg offset-3-lg span-14-sm offset-1-sm span-14-xs offset-1-xs">
              <textarea class="form-text-area p" v-model="otherText" placeholder="If other please specify" v-on:keyup="textToStore('presurvey-2-group', 'What position do you hold?', true)" ref="presurvey-2-group"></textarea>
            </div>
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="border-error-container" :class="[presurvey_3_group]">
          <survey-caption ind="3">Have you received any training on children’s exposure to violence and trauma?</survey-caption>

          <div class="row span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
            <radio-span group="presurvey-3-group" full="true" title="Yes" groupQuestion="Have you received any training on children’s exposure to violence and trauma?"></radio-span>
            <radio-span group="presurvey-3-group" full="true" title="No" groupQuestion="Have you received any training on children’s exposure to violence and trauma?"></radio-span>
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="border-error-container" :class="[presurvey_4_group]">
          <survey-caption ind="4">What is your level of knowledge on children’s exposure to violence and trauma?</survey-caption>

          <div class="row span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
            <radio-span group="presurvey-4-group" full="true" title="Low" groupQuestion="What is your level of knowledge on children’s exposure to violence and trauma?"></radio-span>
            <radio-span group="presurvey-4-group" full="true" title="Medium" groupQuestion="What is your level of knowledge on children’s exposure to violence and trauma?"></radio-span>
            <radio-span group="presurvey-4-group" full="true" title="High" groupQuestion="What is your level of knowledge on children’s exposure to violence and trauma?"></radio-span>
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="border-error-container" :class="[presurvey_5_group]">
          <survey-caption ind="5">Do you think students at your school are affected by violence and trauma?</survey-caption>

          <div class="row span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs padding-bottom-96">
            <radio-span group="presurvey-5-group" full="true" title="Yes" groupQuestion="Do you think students at your school are affected by violence and trauma?"></radio-span>
            <radio-span group="presurvey-5-group" full="true" title="No" groupQuestion="Do you think students at your school are affected by violence and trauma?"></radio-span>
          </div>
        </div>
        <!--  -->

        <!-- end content -->

      </div>
    </div>
  </div>
  <!-- end container -->

</template>

<script>
  import surveyCaption from '../../components/molecules/surveyCaption'
  import radio_span from '../../components/molecules/radio_span'
  import full_span_slide from '../../components/organisms/full_span_slide'
  import vanilla_smooth_scroll from '../../utils/vanilla_smooth_scroll'
  import PerfectScrollbar from 'perfect-scrollbar';

  import {
    apiUrls
  } from '../../utils/api_addresses'
  import "babel-polyfill" // axios IE polyfill
  import axios from 'axios'
  axios.defaults.withCredentials = true;

  export default {
    props: ['active'],
    data() {
      return {
        showErrorMessage: false,
        modifyDOMFlag: false,
        psOne: null,
        otherText: '',
        ...this.initData()
      }
    },
    methods: {
      initData() {
        let data = {}
        const validations = 6
        for (let i = 0; i < validations; i++) {
          data['presurvey_' + i + '_group'] = ''
        }
        return data
      },
      textToStore(r, question, textAreaFlag) {
        textAreaFlag = textAreaFlag || false
        let bool = true
        if (!this.$refs[r].value.length) {
          bool = false
        }
        this.$store.commit('setPreSurvey', {
          [r]: bool
        })
        if (!textAreaFlag) {
          this.$store.commit('setPreSurveyData', {
            question,
            response: this.$refs[r].value
          })
        } else {
          this.$store.commit('setPreSurveyData', {
            question: 'What position do you hold? (Other)',
            response: this.otherText
          })
        }


      },
      checkIncompleteSurvey(options) {

        // returns boolean true if any survey options are falsey or missing in the store.
        options = options || {
          modifyDOM: false
        }
        const validations = 6
        let bool = false
        this.showErrorMessage = false

        for (let i = 0; i < validations; i++) {
          if (!this.$store.state.preSurvey['presurvey-' + i + '-group']) {

            // if a value is either falsey or missing, set the return variable to true
            bool = true

            // display errors if modifyDOM enabled
            if (options.modifyDOM || this.modifyDOMFlag) {
              this.modifyDOMFlag = true
              this.showErrorMessage = true
              this['presurvey_' + i + '_group'] = 'border-error'
            }

          } else {
            this['presurvey_' + i + '_group'] = ''
          }

        }

        return bool
      },
      scrollBarInit() {
        if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
          const containerOne = this.$refs.scrollContainer
          this.psOne = new PerfectScrollbar(containerOne);
        } else if (this.psOne) {
          this.psOne.destroy()
          this.psOne = null
        }
        window.addEventListener('resize', this.scrollBarInit)
      },
      activeCallback() {
        if (this.active) {

          // define callback for store navigation
          const nextButtonCallback = () => {
            if (this.checkIncompleteSurvey({
                modifyDOM: true
              })) {
              setTimeout(() => {
                if (window.innerWidth < 1200) {
                  vanilla_smooth_scroll(0, 1200)
                } else {
                  vanilla_smooth_scroll(0, 1200, null, this.$refs.scrollContainer)
                }
              }, 800)
              // if checkIncomplete returns true / incomplete
              // scroll to top and return false, ending store callback
              return false
            } else {
              // else if checkIncompelte returns false
              // allow navigation / return true / continue next in store cb
              // (store cb will automatically reset custom callback to nothing on success)

              // todo: persist to DB here
              // persist to DB
              console.log('pre survey complete.')
              console.log(this.$store.state.preSurveyData)
              axios.post(apiUrls.server.preSurvey, this.$store.state.preSurveyData)
                .catch((err) => {
                  console.log(err)
                })

              return true
            }
          }

          // commit callback to store
          this.$store.commit('setNextCondition', nextButtonCallback)

          // set scrollbar
          setTimeout(() => {
            this.scrollBarInit()
          }, 1000)
        }
      }
    },
    computed: {
      preSurveyChange() {
        return this.$store.state.preSurvey.changeTrigger
      },
    },
    components: {
      'full-span-slide': full_span_slide,
      'survey-caption': surveyCaption,
      'radio-span': radio_span
    },
    mounted() {
      this.activeCallback()
    },
    watch: {
      active() {
        this.activeCallback()
      },
      preSurveyChange() {
        this.checkIncompleteSurvey()
      }
    },
  }

</script>



// WEBPACK FOOTER //
// pre_survey.vue?1ddf81bc